import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { VisitContext } from './visit.context';

@Component({ selector: 'rv-visit-phone', standalone: true, template: '<ng-content/>', host: { class: 'phone-demo', '[attr.data-decision]': 'visit.decision()' }, changeDetection: ChangeDetectionStrategy.OnPush })
export class VisitPhoneComponent { readonly visit = inject(VisitContext); }
